import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PublishDocumentsInitFormResponse } from '../model/PublishDocumentsInitFormResponse';
import { PublishDocumentsFetchDocsForPublish } from '../model/PublishDocumentsFetchDocsForPublish';

@Injectable({
  providedIn: 'root'
})
export class PublishLettersService {

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  publishDocumentsInitForm() {
    return this.httpClient.get<PublishDocumentsInitFormResponse>(ApiUrls.publishDocumentsInitFormUrl);
  }

  publishDocumentsFetchDocsForPublish(lotteryKey: number, docType: string) {
    return this.httpClient.get<PublishDocumentsFetchDocsForPublish>(
      ApiUrls.publishDocumentsFetchDocsForPublishUrl
      .replace('{lotteryKey}', lotteryKey.toString())
      .replace('{docType}', docType)
      );
  }

  publishDocuments(lotteryKey: number, docType: string) {
    return this.httpClient.post<{status: string, errorMessage: string}>(
      ApiUrls.publishDocumentsUrl
      .replace('{lotteryKey}', lotteryKey.toString())
      .replace('{docType}', docType), null
      );
  }

  publishDocumentsFetchPublishStatus(lotteryKey: number, docType: string) {
    return this.httpClient.get<PublishDocumentsFetchDocsForPublish>(
      ApiUrls.publishDocumentsFetchPublishStatusUrl
      .replace('{lotteryKey}', lotteryKey.toString())
      .replace('{docType}', docType)
      );
  }
  
  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
